<template>
  <div>
    <div class="flex items-center justify-center gap-2">
      <JoszakiHeading class="text-white" :level="1">
        {{ $t("landing.header.title") }}
      </JoszakiHeading>
      <button
        v-if="compactSubtitles && hasProfessionals"
        type="button"
        class="text-white/80 hover:text-white text-xl leading-none"
        :aria-label="$t('landing.header.subtitlesInfo')"
        :aria-expanded="subtitlesVisible ? 'true' : 'false'"
        aria-controls="hero-subtitles"
        @click="toggleSubtitles"
        @mouseenter="subtitlesHovered = true"
        @mouseleave="subtitlesHovered = false"
      >
        <IconComponent icon="info-circle" />
      </button>
    </div>
    <div
      v-if="hasProfessionals"
      id="hero-subtitles"
      :class="{ hidden: compactSubtitles && !subtitlesVisible }"
    >
      <JoszakiHeading :level="2" class="text-white">
        {{ $t("landing.header.subtitle1") }}
      </JoszakiHeading>
      <JoszakiHeading :level="2" class="text-white">
        {{ $t("landing.header.subtitle2") }}
      </JoszakiHeading>
    </div>
  </div>
</template>

<script>
import { computed, ref, useContext } from "@nuxtjs/composition-api";
import { FEATURES } from "~/config/pages/features.config";

export const HERO_SUBTITLES_EXPERIMENT = "front-page-hero-subtitles-toggle";

export default {
  name: "HeroTitle",
  setup() {
    const { $ab, $branding, $trackers } = useContext();

    const hasProfessionals = $branding.hasFeature(FEATURES.PROFESSIONALS);
    const compactSubtitles = $ab.isVariant(HERO_SUBTITLES_EXPERIMENT, "test");
    const subtitlesOpened = ref(false);
    const subtitlesHovered = ref(false);
    const subtitlesVisible = computed(
      () => subtitlesOpened.value || subtitlesHovered.value
    );

    const toggleSubtitles = () => {
      subtitlesOpened.value = !subtitlesOpened.value;
      if (subtitlesOpened.value) {
        $trackers.trackClick("HeroSubtitlesInfo");
      }
    };

    return {
      hasProfessionals,
      compactSubtitles,
      subtitlesHovered,
      subtitlesVisible,
      toggleSubtitles,
    };
  },
};
</script>
